import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MedicineService } from 'src/core/services/medicine.service';
import { dosageUnitSelectedValidator } from 'src/core/validators/dosage-unit';
import { CreateDosageTypePayload, DosageType, DosageUnit } from 'src/interfaces/medicine';

export interface DialogData {
  title: string;
  message: string;
  dosageUnits: DosageUnit[];
}
@Component({
    selector: 'app-dosage-type-create-dialog',
    templateUrl: './dosage-type-create-dialog.component.html',
    styleUrls: ['./dosage-type-create-dialog.component.scss'],
    standalone: false
})
export class DosageTypeCreateDialogComponent implements OnInit {

  dosageTypeForm = this._formBuilder.group({
    type: ['', Validators.required],
    code: ['', Validators.required],
    dosageUnit: ['', dosageUnitSelectedValidator]
  });

  dosageUnits: DosageUnit[];

  constructor(
    public _dialogRef: MatDialogRef<DosageTypeCreateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private _formBuilder: UntypedFormBuilder,
    private _medicineService: MedicineService
  ) { }

  ngOnInit(): void {
    this.dosageUnits = this.data.dosageUnits;
  }

  async createDosageType() {

    const payload: CreateDosageTypePayload = {
      type: this.dosageTypeForm.value.type,
      code: this.dosageTypeForm.value.code,
      dosage_unit_id: this.dosageTypeForm.value.dosageUnit.id
    };

    const createdDosageType: DosageType | null = await this._medicineService
      .createDosageType(payload)

    if (createdDosageType)
      this._dialogRef.close(createdDosageType);
  }

  onDosageUnitCreated(newDosageUnit: DosageUnit) {
    this.dosageUnits.push(newDosageUnit);
    this.dosageUnits = [...this.dosageUnits];
  }

  onDosageUnitsManaged(dosageUnits: DosageUnit[]) {
    this.dosageUnits = dosageUnits;
  }

}
